// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"163":"61876fc5","255":"e3512d36","667":"40b532a0","921":"40b532a0"}[chunkId] + ".chunk.css";
};